import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CargoFacilityRoutingModule } from './cargo-facility-routing.module';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        CargoFacilityRoutingModule
    ]
})
export class CargoFacilityModule { }
